import React, { Component } from 'react'
import SelectSearchItem from '../../../ui/select/SelectSearchItems'
import RowCard from './components/RowCard';
import AccordionCard from '../../../ui/cards/AccordionCard';


const options = [
    { value: 'full', label: 'Full Matches (4)' },
    { value: 'goals', label: 'Goals (9)' },
    { value: 'short', label: 'Short Passes (46)' },
    { value: 'assists', label: 'Assists (10)' },
    { value: 'long', label: 'Long Passes (20)' },
    { value: 'smart', label: 'Smart Passes (4)' },
    { value: 'crosses', label: 'Crosses (10)' },
    { value: 'fouls', label: 'Fouls (2)' },
    { value: 'dribbling', label: 'Dribbling (30)' },
];

class VideoClips extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             
        }
    }
    
    render() {
        return (
            <div className="left-side-content">
                {this.renderSelect()}
                {this.renderCards()}
            </div>
        )
    }

    renderSelect = () => {
        return (
            <SelectSearchItem
                type="lg"
                name="videoType"
                placeholder="Full Match Video"
                searchPlaceholder="Search Video Type"
                onChange={console.log}
                options={options}
            />
        )
    }

    renderCards = () => {
        return (
            <div className="collapsable-cards">
                {
                    this.props.list.map(card => (
                        <AccordionCard
                            key={card.id}
                            title={card.title}
                            text={card.text}
                        >
                            {
                                card.items.map(item => (
                                    <RowCard
                                        key={item.id}
                                        id={item.id}
                                        title={item.title}
                                        actions={this.props.actions}
                                    />
                                ))
                            }
                        </AccordionCard>
                    ))
                }
            </div>
        )
    }
}

export default VideoClips
